import { createStore, compose, applyMiddleware, combineReducers } from '@reduxjs/toolkit';
import thunk from 'redux-thunk';
import AuthReducer from '../reducers/Auth';
import EventReducer from '../reducers/EventReducer';
import SnackReducer from '../reducers/SnackReducer';
import StorageReducer from '../reducers/StorageReducer';

const reducers = combineReducers({
  auth: AuthReducer,
  events: EventReducer,
  snack: SnackReducer,
  storage: StorageReducer
});

const store = createStore(
  reducers,
  {},
  compose(applyMiddleware(thunk))
);

export { store as default };
